































































































import { Component, Vue } from 'vue-property-decorator'
import { CommonModule } from '@/store/modules/common'
import {
  callAppFunc_getSomeParams,
  appFunc_senToken,
  appFunc_sendOpenImage,
  appFunc_RegisterFinishCb
} from '@/utils/bridge'
import { Toast } from 'vant'
import { ImagePreview } from 'vant'
import { submitFeedback } from '@/api'
@Component({
  name: 'Problem',
  components: {}
})
export default class Problem extends Vue {
  // 表单信息
  form = {
    // 提交用户的手机号
    mobile: '',
    // 意见文本
    text: '',
    androidVersion: '',
    equipmentNumber: '',
    // 被投诉人手机号
    respondent: '',
    // 图片链接数组
    pictures: [] as any,
    version: ''
  }

  loading = false

  created() {
    this.getToken()
    this.getSomeData()
    // 获取当前语言
    const data = (this.$route.query.language as string) || 'ug'
    this.getLanguage(data)
  }

  async getSomeData() {
    const res = await callAppFunc_getSomeParams()
    console.log(res, 'getSomeData', '////////////////////////////')
    this.form.mobile = res.mobile
    this.form.respondent = res.respondent
    this.form.androidVersion = res.sysversion
    this.form.equipmentNumber = res.devicemodel
    this.form.version = res.versionName
  }

  async getToken() {
    const res = await appFunc_senToken()
    console.log(res, '获取token')
    CommonModule.setUserId(res.id)
    CommonModule.setToken(res.tokenForJs)
  }

  // 当前语言
  get language() {
    return this.$i18n.locale
  }

  // 切换语言
  getLanguage(language: string) {
    this.$i18n.locale = language
  }

  // 上传图片
  handelUpload() {
    if (this.form.pictures.length >= 5) {
      Toast(this.$t('最多只能上传五张图片'))
      return
    }
    appFunc_sendOpenImage()
    appFunc_RegisterFinishCb(this.handelFinish)
  }

  handelFinish(data: any) {
    console.log(data, '////////')
    if (data.length !== 0) {
      data.map((item: any) => {
        this.form.pictures.push(item)
      })
      if (this.form.pictures.length > 5) {
        Toast(this.$t('最多只能上传五张图片'))
      }
      this.form.pictures.splice(5)
    }
    console.log(JSON.parse(this.form.pictures), '返回图片路径')
  }

  // 预览图片
  handelImg(images: any, index: any) {
    console.log(images, index)
    ImagePreview({
      images: images,
      showIndex: true,
      loop: false,
      startPosition: index
    })
  }

  // 删除图片
  handelDel(index: number) {
    this.form.pictures.splice(index, 1)
  }

  async handelSubmit() {
    const tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
    if (!tel.test(this.form.mobile)) {
      return Toast(this.$t('请正确填写您的联系电话'))
    }
    const { code, message } = await submitFeedback({
      mobile: this.form.mobile,
      text: this.form.text,
      equipmentNumber: this.form.equipmentNumber,
      androidVersion: this.form.androidVersion,
      respondent: this.form.respondent,
      imgs: JSON.stringify(this.form.pictures),
      version: this.form.version
    })
    this.loading = true
    if (code == 1001) {
      this.loading = false
      this.form.text = ''
      this.form.mobile = ''
      this.form.pictures = []
      Toast(this.$t('提交成功'))
    } else {
      this.loading = false
      Toast(message)
    }
  }

  //   返回常见问题反馈
  handelback() {
    this.$router.push({
      path: '/feedback',
      query: {
        language: this.language
      }
    })
  }
}
